import { Typography } from '@euler/app/components/typography';
import { ApdmImportSummary } from '@euler/functions/apdm/import/importState';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';
import { useTheme } from 'styled-components';
import { skipReasonLabel } from '../../functions/skipReasonLabel';

/** Why rows were left out, and which item names were not recognized. */
export function LeftOutDetails({
  leftOut,
}: {
  leftOut: ApdmImportSummary['leftOut'];
}) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  const line = (text: string) => (
    <Typography.Text key={text} size={rpx(13)} color={theme.label.color}>
      {text}
    </Typography.Text>
  );
  return (
    <View style={{ marginTop: rpx(8), gap: rpx(4) }}>
      {leftOut.byReason.map(entry =>
        line(`${skipReasonLabel(entry.reason)}：${entry.rows} 行`),
      )}
      {leftOut.notCompleted
        ? line(`未完工或已作废：${leftOut.notCompleted} 行，不计来店`)
        : null}
      {leftOut.washOnly
        ? line(`只洗车：${leftOut.washOnly} 单，不计来店也不计保养`)
        : null}
      {leftOut.topUnknownItems.length ? (
        <View style={{ marginTop: rpx(4) }}>
          <Typography.Text size={rpx(13)} bold color={theme.label.color}>
            未识别的项目
          </Typography.Text>
          {leftOut.topUnknownItems.map(item =>
            line(`${item.text} · ${item.count} 次`),
          )}
        </View>
      ) : null}
    </View>
  );
}
